<template>
	<v-container class="pa-0">
		<v-row justify="center" class="text-center">
			<v-col cols="12" md="12" sm="12" class="pl-12 pr-12 text-center">
				<v-img
					contain
					lazy-src="https://picsum.photos/id/11/10/6"
					:src="image"
				></v-img>
			</v-col>
			<v-col cols="12" md="12" sm="12" class="pt-2 text-center">
				<base-title
					:title="title"
					class="text-uppercase text-center"
					space="3"
				/>
				<base-body
					v-if="text || $slots.default"
					:space="horizontal ? 0 : undefined"
					:text="text"
					class="text-center"
					max-width="700"
				>
					<slot />
				</base-body>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
// Mixins
import Heading from '@/mixins/heading'

export default {
	name: 'BaseAvatarCard',

	mixins: [Heading],

	props: {
		align: {
			type: String,
			default: 'left',
		},
		color: String,
		dark: Boolean,
		icon: String,
		outlined: {
			type: Boolean,
			default: true,
		},
		space: {
			type: [Number, String],
			default: 8,
		},
		size: {
			type: [Number, String],
			default: 72,
		},
		text: String,
		title: String,
		image: String,
		rounded: {
			Boolean,
			default: true,
		},
	},

	computed: {
		classes() {
			const classes = [`mb-${this.space}`]

			if (this.horizontal) {
				classes.push('d-flex')

				if (!this.$slots.default && !this.text) {
					classes.push('align-center')
				}
			}

			return classes
		},
	},
}
</script>
